// extracted by mini-css-extract-plugin
export default {"loader":"VerificationWrapper_loader__KyrGP"};